// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "v0.0.8-528-g5748580-dirty",
    "hash": "g5748580",
    "distance": 528,
    "tag": "v0.0.8",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v0.0.8",
        "major": 0,
        "minor": 0,
        "patch": 8,
        "prerelease": [],
        "build": [],
        "version": "0.0.8"
    },
    "suffix": "528-g5748580-dirty",
    "semverString": "0.0.8+528.g5748580",
    "version": "0.0.44",
    "date": "2025-09-03T08:08:38.256Z"
};
/* tslint:enable */
